import actions from '../js/actions.js';
import URLS from '../js/Urls.js';
import $$ from 'Dom7';
export default {
  data: function () {// Must return an object
    // return {
    //   name: 'Jimmy2',
    //   age: 25,
    //   like: ['Tennis', 'Chess', 'Football'],
    // }
  },
  // Component Methods
  methods: {
    openAlert: function () {
      var self = this;
      self.$app.dialog.alert('Hello World');
    }
  },
  // Page Events
  on: {
    pageMounted: function (e, page) {
      console.log('pageMounted', page);
    },
    pageInit: function (e, page) {
      console.log('pageInit', page);
      var loginobj = actions.LoginGetResult();
      var url = URLS.ManageArrivalsIntelligent + '?PropertyID=' + loginobj.PropertyID + "&ReportType=ManageArrivalsIntelligent";
      var iframe = $$('<iframe src="' + url + '" width="100%" height="100%"></iframe>');
      $$('.page-content').prepend(iframe);
    },
    pageBeforeOut: function (e, page) {
      console.log('pageBeforeOut', page);
    },
    pageAfterOut: function (e, page) {
      console.log('pageAfterOut', page);
    },
    pageBeforeRemove: function (e, page) {
      console.log('pageBeforeRemove', page);
    }
  },
  id: '982c9b1f54',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '<div class=page><div class=navbar><div class=navbar-bg></div><div class="navbar-inner sliding"><div class=left><a href=# class="link back"><i class="icon icon-back"></i> <span class=if-not-md>Back</span></a></div><div class=title>tst</div></div></div><div class=page-content></div></div>';
      return r;
    }(this);
  },

  style: `
  .page-content {
    padding: 0px;
  }
`,
  styleScoped: false
};